import Proj1 from "../assets/project1.png";
import Proj2 from "../assets/proj2.jpg";
import Proj3 from "../assets/proj3.webp";
import Proj4 from "../assets/proj4.webp";
import Proj5 from "../assets/proj5.jpg";
import Proj6 from "../assets/project6.png";

export const ProjectList = [
  {
    name: "Nike Shop Clone",
    image: Proj1,
    skills: "JavaScript,HTML,CSS",
  },
  {
    name: "Ecommerce Website",
    image: Proj2,
    skills: "Html,React,Javascript,Bootstrap",
    
  },
  {
    name: "Spotify Clone",
    image: Proj3,
    skills: "React,Material Ui,Javascript,",
  },
  {
    name: "Social Media Website",
    image: Proj4,
    skills: "React,Javascript,Sass",
  },
  {
    name: "Dashboard Visualizer",
    image: Proj5,
    skills: "JavaScript,HTML,CSS",
  },
  {
    name: "School Material",
    image: Proj6,
    skills: "JavaScript,HTML,CSS",
    href: "https://comandante2000.github.io/module/",
  },
];
